import React from 'react';

import { ContextWrapper } from './context';

import './assets/css/styles.css';
import './assets/css/preloader.css';

export function wrapPageElement({ element, props }) {
  return (
    <ContextWrapper {...props}>{element}</ContextWrapper>
  );
}
